import React, { useState } from "react";
import BulkCsvModal from "./BulkCsvModal";
import { SYSTEM_FIELDS } from "./constants";
import { isMappingMissingRequiredFields } from "./csvUtils";
import AutoCompleteDropdown from "Components/common/AutoCompleteDropdown";

// Same {value, name} shape AutoCompleteDropdown expects everywhere else in
// the product (e.g. CRM field mapping) — built once, not per row.
const FIELD_OPTION_LIST = SYSTEM_FIELDS.map(field => ({
  value: field.key,
  name: field.label
}));
const FIELD_LABEL_BY_KEY = SYSTEM_FIELDS.reduce((acc, field) => {
  acc[field.key] = field.label;
  return acc;
}, {});

const StatusPill = (props = {}) => {
  const { mapped = false } = props || {};
  return (
    <span
      className={`bulkCsvStatusPill ${mapped ? "pillMapped" : "pillReview"}`}
    >
      {mapped ? "Mapped" : "Review"}
    </span>
  );
};

const StepMapColumns = (props = {}) => {
  const {
    onClose = () => { },
    onBack = () => { },
    onNext = () => { },
    initialMapping = []
  } = props || {};
  const [mapping, setMapping] = useState(initialMapping);
  // Which row's dropdown is currently open — that row's cell gets a raised
  // z-index (see openDropdownCell below) so its option panel isn't painted
  // over by the rows that follow it in the table (a plain z-index on the
  // panel alone only wins within its own stacking context; the containing
  // cell needs to be elevated too for it to actually show above later rows).
  const [openRowIndex, setOpenRowIndex] = useState(null);

  const updateFieldKey = (colIndex, fieldKey) => {
    const next = [...mapping];
    next[colIndex] = { ...next[colIndex], fieldKey, autoMapped: false };
    setMapping(next);
  };

  const missingRequired = isMappingMissingRequiredFields(mapping);

  return (
    <BulkCsvModal
      title="Map columns"
      subtitle={`${mapping.length} columns detected — confirm the mapping below`}
      onClose={onClose}
      wide
      footer={
        <>
          <button
            type="button"
            id="bulkCsvMapBack"
            className="bulkCsvBtnGhost"
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="button"
            id="bulkCsvMapContinue"
            className="bulkCsvBtnPrimary"
            disabled={missingRequired}
            onClick={() => onNext(mapping)}
          >
            Continue
          </button>
        </>
      }
    >
      {missingRequired && (
        <div className="bulkCsvErrorBox">
          <span className="errorText">
            Make sure to map Email, SMTP host, SMTP port, IMAP host, and IMAP port to connect your inboxes.
          </span>
        </div>
      )}
      <div className="bulkCsvTableWrapper noInnerScroll">
        <table>
          <thead>
            <tr>
              <th style={{ width: "28%" }}>CSV column</th>
              <th style={{ width: "44%" }}>Maps to</th>
              <th style={{ width: "28%" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {mapping.map((col, index) => (
              <tr key={`${col.rawHeader}-${index}`}>
                <td>
                  <span className="rawHeaderTag">{col.rawHeader}</span>
                </td>
                <td
                  className={openRowIndex === index ? "openDropdownCell" : ""}
                >
                  <AutoCompleteDropdown
                    optionList={FIELD_OPTION_LIST}
                    defaultValue={FIELD_LABEL_BY_KEY[col.fieldKey]}
                    cbk={item => updateFieldKey(index, item.value)}
                    index={`bulkCsvMapSelect-${index}`}
                    showDropdown={openRowIndex === index}
                    setShowDropdown={open =>
                      setOpenRowIndex(open ? index : null)
                    }
                    crm
                  />
                </td>
                <td>
                  <StatusPill mapped={col.fieldKey !== "ignore"} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </BulkCsvModal>
  );
};

export default StepMapColumns;
export { StepMapColumns };
